export default {
    methods: {
        getImageUrl: function (fileName) {
            return `https://keys-so-rsya.keys.so/rsya-images/${fileName}`;
        }
    },
}
